/**
 * ActivityDialogFooter — shared footer for activity detail dialogs.
 *
 * Edit mode: [Delete icon]  [Cancel] [Save Changes]
 * View mode: [Edit icon?]            [Close]
 *
 * Used by TaskDetailDialog, CommunicationDetailDialog, HospitalityDetailDialog.
 */
import React from 'react';
import { DialogFooter } from '../../../ui/dialog';
import { Button } from '../../../ui/button';
import { Pencil, Trash2 } from 'lucide-react';

const ActivityDialogFooter = ({
  isEditing,
  saving,
  onSave,
  onCancel,
  onDelete,
  onClose,
  onEdit,          // optional — shows an edit pencil on the left in view mode
  canEdit = false, // whether to show the edit button in view mode
  deleteTestId,
  editTestId,
  saveLabel = 'Save Changes',
}) => (
  <DialogFooter>
    {isEditing ? (
      <div className="flex justify-between w-full">
        <Button
          variant="ghost"
          size="icon"
          onClick={onDelete}
          disabled={saving}
          data-testid={deleteTestId}
        >
          <Trash2 className="w-4 h-4" />
        </Button>
        <div className="flex gap-2">
          <Button variant="outline" onClick={onCancel} disabled={saving}>Cancel</Button>
          <Button onClick={onSave} disabled={saving}>
            {saving ? 'Saving...' : saveLabel}
          </Button>
        </div>
      </div>
    ) : (
      <div className="flex justify-between w-full">
        {canEdit && onEdit && (
          <Button variant="ghost" size="icon" onClick={onEdit} data-testid={editTestId}>
            <Pencil className="w-4 h-4" />
          </Button>
        )}
        <Button variant="outline" onClick={onClose} className="ml-auto">Close</Button>
      </div>
    )}
  </DialogFooter>
);

export default ActivityDialogFooter;
